export const LOGO_MAIN = "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/nq733ag4_noBgBlack.webp";
export const LOGO_LIGHT = "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/djg9su1p_noBgColor.webp";
export const LOGO_BADGE = "https://customer-assets-lqy194kg.emergentagent.net/job_asas-profili-dist/artifacts/2j56o6nt_with_padding.webp";

export const SITE = {
  companyName: "HGW Industry",
  fullName: "HGW Industry S.r.l.",
  tagline: "High Grade Windows.",
  headOffice: {
    street: "Via Zingariello SNC",
    city: "Somma Vesuviana",
    province: "NA",
    zip: "80049",
    country: "Italia",
  },
  email: "info@hgwindustry.com",
  emailB2b: "info@hgwindustry.com",
  phone: "+39 081 19638544",
  whatsapp: "+39 392 6952497",
  whatsappRaw: "393926952497",
  instagram: "https://www.instagram.com/hgwindustry/",
  facebook: "https://www.facebook.com/share/1C7vS4TLMQ/?mibextid=wwXIfr",
  linkedin: "",
  showrooms: [
    {
      id: "somma-vesuviana",
      city: "Somma Vesuviana",
      province: "NA",
      street: "Via Zingariello SNC",
      zip: "80049",
      country: "Italia",
      hours: "LUN — VEN · 09:00 → 18:00 · SAB su appuntamento",
      lat: 40.884806,
      lon: 14.440333,
    },
  ],
  vat: "P.IVA 10396611211 · REA NA-1103123",
  founded: 2007,
};

/** Partner brands — reference logos, not clickable */
export const PARTNERS = [
  {
    id: "winperax",
    name: "WINPERAX",
    it: "Pergole bioclimatiche e soluzioni outdoor che integrano comfort, tecnologia e design.",
    en: "Bioclimatic pergolas and outdoor solutions that integrate comfort, technology and design.",
    badgeIt: "Distributore esclusivo per l'Italia",
    badgeEn: "Exclusive Italian distributor",
  },
  {
    id: "asas",
    name: "ASAŞ",
    it: "Sistemi in alluminio e PVC per l'architettura contemporanea, sviluppati per coniugare design, prestazioni e versatilità.",
    en: "Aluminium and PVC systems for contemporary architecture, developed to combine design, performance and versatility.",
    badgeIt: "Distributore ufficiale per l'Italia",
    badgeEn: "Official Italian distributor",
  },
];

/** Certifications & quality standards */
export const CERTIFICATIONS = [
  {
    id: "ce",
    label: "Marcatura CE",
    status: "active",
    it: "Tutti i nostri prodotti sono certificati con marcatura CE, conforme alle direttive UE per la commercializzazione nell'area economica europea.",
    en: "All our products carry CE marking, compliant with EU directives for commercialisation in the European Economic Area.",
  },
  {
    id: "iso-9001",
    label: "ISO 9001",
    status: "active",
    it: "Sistema di gestione della qualità. Certifica processi produttivi, controlli qualità e soddisfazione del cliente secondo lo standard internazionale.",
    en: "Quality management system. Certifies manufacturing processes, quality controls and customer satisfaction against the international standard.",
  },
  {
    id: "iso-45001",
    label: "ISO 45001",
    status: "active",
    it: "Sistema di gestione per la salute e sicurezza sul lavoro. Definisce i requisiti per prevenire incidenti e tutelare tutti gli operatori.",
    en: "Occupational health and safety management system. Sets requirements to prevent accidents and protect every worker.",
  },
  {
    id: "sac-1",
    label: "SAC 1",
    status: "in-progress",
    it: "Sistema di Attestazione della Conformità di livello 1 (UNI EN 14351-1). Qualificazione del produttore per la marcatura CE di porte pedonali installate su vie di fuga, con controllo continuo di un Organismo Notificato.",
    en: "Level 1 Conformity Attestation System (UNI EN 14351-1). Manufacturer qualification for CE marking of pedestrian doors on emergency escape routes, with continuous oversight by a Notified Body.",
  },
];

/** Home KPIs — update these numbers as the business grows */
export const NUMBERS = [
  {
    id: "progetti",
    value: 80,
    suffix: "+",
    it: "Progetti realizzati",
    en: "Projects delivered",
  },
  {
    id: "mq",
    value: 5000,
    suffix: "+",
    it: "m² di serramenti prodotti",
    en: "m² of joinery produced",
  },
  {
    id: "clienti",
    value: 30,
    suffix: "+",
    it: "Clienti B2B in Italia",
    en: "B2B clients across Italy",
  },
  {
    id: "regioni",
    value: 20,
    suffix: "",
    it: "Regioni servite in Italia",
    en: "Regions served across Italy",
  },
];

/** Nav items */
export const NAV = [
  { id: "home", to: "/", it: "Home", en: "Home" },
  { id: "prodotti", to: "/prodotti", it: "Prodotti", en: "Products" },
  { id: "cataloghi", to: "/cataloghi", it: "Cataloghi", en: "Catalogues" },
  { id: "chi-siamo", to: "/chi-siamo", it: "Chi siamo", en: "About" },
  { id: "contatti", to: "/contatti", it: "Contatti", en: "Contact" },
];

/** Home media — replace with real videos/images */
export const HOME_MEDIA = [
  {
    id: "workshop",
    type: "image",
    src: "https://images.unsplash.com/photo-1608126841830-53832c4b326f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHwzfHxhbHVtaW5pdW0lMjB3aW5kb3clMjBmcmFtZSUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg0MTM1NjQ2fDA&ixlib=rb-4.1.0&q=85",
    title: { it: "Il nostro atelier", en: "Our atelier" },
  },
  {
    id: "assembly",
    type: "image",
    src: "https://images.unsplash.com/photo-1758998256408-ab2c9fbec19b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTN8MHwxfHNlYXJjaHw0fHxhbHVtaW5pdW0lMjB3aW5kb3clMjBmcmFtZSUyMG1hbnVmYWN0dXJpbmd8ZW58MHx8fHwxNzg0MTM1NjQ2fDA&ixlib=rb-4.1.0&q=85",
    title: { it: "Produzione interna", en: "In-house production" },
  },
  {
    id: "pergola-day",
    type: "image",
    src: "https://images.unsplash.com/photo-1762715576863-a10e7c38b5ed?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBwZXJnb2xhJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDEzNTY1MXww&ixlib=rb-4.1.0&q=85",
    title: { it: "Pergole in opera", en: "Pergolas on-site" },
  },
  {
    id: "pergola-detail",
    type: "image",
    src: "https://images.unsplash.com/photo-1633354747567-e0682586f082?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBwZXJnb2xhJTIwZGVzaWduJTIwYXJjaGl0ZWN0dXJlfGVufDB8fHx8MTc4NDEzNTY1MXww&ixlib=rb-4.1.0&q=85",
    title: { it: "Dettaglio lama bioclimatica", en: "Bioclimatic louver detail" },
  },
];

export const COPY = {
  it: {
    // Hero — big slogan + small tagline
    heroTitle: "La forma dell'eccellenza.",
    heroSub: "Produciamo finestre e serramenti in alluminio e PVC, unendo design, tecnologia e precisione industriale. Completiamo la nostra offerta con sistemi architettonici e soluzioni outdoor per ogni esigenza progettuale.",
    heroCtaProducts: "Scopri i prodotti",
    heroCtaContact: "Contattaci",

    // Company intro / storytelling (Chi siamo)
    introEyebrow: "Chi siamo",
    homeIntroTitle: "La qualità nasce dalla produzione.",
    homeIntroBody: "HGW Industry è un'azienda italiana specializzata nella produzione di finestre e serramenti in alluminio e PVC.",
    homeIntroBody2: "Uniamo competenza industriale, tecnologie produttive e collaborazioni internazionali per offrire sistemi architettonici che coniugano estetica, funzionalità e prestazioni. Affianchiamo privati, professionisti e imprese attraverso soluzioni curate in ogni dettaglio, dalla consulenza tecnica alla produzione e alla fornitura.",
    homeMissionBody: [
      "Produrre serramenti e offrire sistemi architettonici che integrano design, tecnologia e prestazioni.",
      "Valorizziamo la manifattura italiana attraverso competenze industriali, innovazione e attenzione alla qualità.",
    ],
    homeVisionBody: [
      "Essere un punto di riferimento nel settore dei serramenti e delle soluzioni architettoniche, distinguendoci per affidabilità, competenza e capacità di innovazione.",
    ],
    homeProductsTitle: "Sistemi progettati per distinguersi.",
    homeProductsBody: "Dalle finestre e dai serramenti in alluminio e PVC ai grandi sistemi scorrevoli, fino alle pergole bioclimatiche e alle coperture. Soluzioni che uniscono qualità costruttiva, funzionalità e design.",
    homeContactTitle: "Diamo forma alle tue idee.",
    homeContactBody: "Ogni progetto merita la soluzione giusta. Contattaci per conoscere i nostri sistemi e trovare insieme la risposta alle tue esigenze.",
    introTitle: "Produzione italiana, standard internazionali.",
    introBody: "HGW Industry è un'azienda italiana specializzata nella produzione di finestre e serramenti in alluminio e PVC. Uniamo competenza industriale, tecnologie produttive e collaborazioni internazionali per realizzare sistemi che coniugano estetica, funzionalità e prestazioni.",
    introBody2: "Ogni serramento nasce da un processo controllato in ogni fase: dalla consulenza tecnica alla progettazione, dalla lavorazione dei profili all'assemblaggio, fino alla fornitura. Un unico interlocutore, meno passaggi e una qualità verificabile nel tempo.",
    introBody3: "Affianchiamo privati, architetti, progettisti, imprese e serramentisti in tutta Italia, con un approccio preciso e orientato al risultato. Investiamo con continuità in tecnologie, processi e persone, perché la qualità di un serramento si costruisce prima di tutto in produzione.",
    introBody4: "Siamo distributori ufficiali ASAŞ per l'Italia: sistemi in alluminio e PVC di uno dei più grandi produttori europei, con cui realizziamo finestre, scorrevoli, facciate e soluzioni per l'architettura contemporanea.",
    introBody5: "Completiamo la nostra offerta con Winperax, di cui siamo distributori esclusivi per l'Italia: pergole bioclimatiche e soluzioni outdoor che integrano comfort, tecnologia e design.",
    introSignature: "HGW Industry. La forma dell'eccellenza.",

    // Partners section
    partnersEyebrow: "I nostri partner",
    partnersTitle: "Partner di valore.",
    partnersBody: "Collaboriamo con realtà internazionali selezionate per qualità, tecnologia e innovazione, ampliando le possibilità progettuali e produttive di HGW Industry.",

    // Certifications section
    certEyebrow: "Certificazioni & Qualità",
    certTitle: "Standard riconosciuti a garanzia del lavoro.",
    certBody: "Ogni prodotto che esce dalla nostra produzione risponde a standard internazionali di qualità e sicurezza — verificati o in corso di ottenimento.",
    certStatusActive: "Attiva",
    certStatusInProgress: "In certificazione",

    // Numbers section (replaces "Inside the atelier")
    numbersEyebrow: "I numeri parlano",
    numbersTitle: "I risultati del nostro impegno.",
    numbersBody: "Ogni progetto racconta la nostra crescita. Capacità produttiva, esperienza e attenzione alla qualità sono i valori che guidano quotidianamente il nostro lavoro.",

    // Mission / Vision — manifesto style (arrays rendered as separate lines)
    mvEyebrow: "Mission & Vision",
    mvTitle: "Una visione precisa. Un impegno concreto.",
    missionLabel: "Mission",
    missionBody: [
      "Produrre serramenti e offrire sistemi architettonici che integrano design, tecnologia e prestazioni.",
      "Valorizzare la manifattura italiana attraverso competenze industriali, innovazione e attenzione alla qualità.",
      "Selezionare partner internazionali che condividono i nostri standard.",
      "Seguire ogni progetto con cura, dalla consulenza alla fornitura."
    ],
    visionLabel: "Vision",
    visionBody: [
      "Essere un punto di riferimento nel settore dei serramenti e delle soluzioni architettoniche.",
      "Distinguerci per affidabilità, competenza e capacità di innovazione.",
      "Un partner unico per privati, professionisti e imprese.",
      "Per chi cerca estetica, prestazioni e durata nel tempo."
    ],

    // Products landing
    productsEyebrow: "Prodotti",
    productsTitle: "Due mondi. Un solo standard.",
    productsBody: "Scegli il tuo percorso: sistemi architettonici per la casa e per l'ufficio, o pergole e coperture automatiche per lo spazio esterno.",
    catArchTitle: "Sistemi Architettonici",
    catArchSub: "Serramenti in alluminio e PVC, sistemi scorrevoli e soluzioni per l'architettura contemporanea.",
    catPergoleTitle: "Pergole & Coperture",
    catPergoleSub: "Pergole bioclimatiche, vetrate e soluzioni outdoor per valorizzare gli spazi esterni.",

    // Contact
    contactEyebrow: "Contatti",
    contactTitle: "Parliamo del tuo progetto.",
    contactBody: "Scrivici per un sopralluogo, un preventivo, o un rapporto di partnership. Rispondiamo entro 24 ore.",
    contactShowroomTitle: "Il nostro showroom",
    contactSend: "Invia richiesta",

    // Footer / misc
    b2bLogin: "Area riservata",
    portal: "Area riservata",
    backToProducts: "Torna ai prodotti",
    seeProducts: "Vedi prodotti",
    seeAll: "Vedi tutti",
    startProject: "Richiedi preventivo",
    features: "Caratteristiche principali",
    finishes: "Finiture disponibili",
    applications: "Applicazioni tipiche",
    partOf: "Fa parte di",
    brochureLabel: "Scheda tecnica",
  },
  en: {
    homeContactBody: "Every project deserves the right solution. Contact us to discover our systems and find the answer to your needs together.",
    homeVisionBody: [
      "To be a point of reference in the window, door and architectural solutions sector, standing out for reliability, expertise and capacity for innovation."
    ],
    homeMissionBody: [
      "To manufacture windows and doors and offer architectural systems that integrate design, technology and performance.",
      "We champion Italian manufacturing through industrial expertise, innovation and a focus on quality."
    ],
    heroTitle: "The shape of excellence.",
    heroSub: "We manufacture aluminium and PVC windows and doors, combining design, technology and industrial precision. We complete our offer with architectural systems and outdoor solutions for every project need.",
    heroCtaProducts: "Explore products",
    heroCtaContact: "Contact us",

    introEyebrow: "About us",
    homeIntroTitle: "Quality starts in production.",
    homeIntroBody: "HGW Industry is an Italian company specialised in manufacturing aluminium and PVC windows and doors.",
    homeIntroBody2: "We combine industrial expertise, production technology and international partnerships to deliver architectural systems that bring together aesthetics, functionality and performance. We support homeowners, professionals and companies with solutions crafted in every detail, from technical advice to production and supply.",
    homeProductsTitle: "Systems designed to stand out.",
    homeProductsBody: "From aluminium and PVC windows and doors to large sliding systems, through to bioclimatic pergolas and covers. Solutions that combine build quality, functionality and design.",
    homeContactTitle: "Let's shape your ideas.",
    introTitle: "Italian manufacturing, international standards.",
    introBody: "HGW Industry is an Italian company specialised in manufacturing aluminium and PVC windows and doors. We combine industrial expertise, production technology and international partnerships to create systems that bring together aesthetics, functionality and performance.",
    introBody2: "Every window is the result of a process controlled at every stage: from technical advice to design, from profile processing to assembly and supply. A single point of contact, fewer steps and quality you can rely on over time.",
    introBody3: "We support homeowners, architects, designers, contractors and window fabricators across Italy with a precise, results-driven approach. We invest continuously in technology, processes and people, because the quality of a window is built first of all in production.",
    introBody4: "We are the official ASAŞ distributor for Italy: aluminium and PVC systems from one of Europe's largest manufacturers, with which we build windows, sliders, facades and solutions for contemporary architecture.",
    introBody5: "We complete our offer with Winperax, for which we are the exclusive distributor in Italy: bioclimatic pergolas and outdoor solutions that integrate comfort, technology and design.",
    introSignature: "HGW Industry. The shape of excellence.",

    partnersEyebrow: "Our partners",
    partnersTitle: "Valued partners.",
    partnersBody: "We work with international companies selected for quality, technology and innovation, expanding HGW Industry's design and production possibilities.",

    certEyebrow: "Certifications & Quality",
    certTitle: "Recognised standards backing our work.",
    certBody: "Every product leaving our facility meets international quality and safety standards — verified or in progress.",
    certStatusActive: "Active",
    certStatusInProgress: "In progress",

    numbersEyebrow: "The numbers speak",
    numbersTitle: "The results of our commitment.",
    numbersBody: "Every project tells the story of our growth. Production capacity, experience and attention to quality are the values that guide our work every day.",

    mvEyebrow: "Mission & Vision",
    mvTitle: "A clear vision. A concrete commitment.",
    missionLabel: "Mission",
    missionBody: [
      "To manufacture windows and doors and offer architectural systems that integrate design, technology and performance.",
      "To champion Italian manufacturing through industrial expertise, innovation and a focus on quality.",
      "To select international partners who share our standards.",
      "To follow every project with care, from advice to supply."
    ],
    visionLabel: "Vision",
    visionBody: [
      "To be a point of reference in the window, door and architectural solutions sector.",
      "To stand out for reliability, expertise and capacity for innovation.",
      "A single partner for homeowners, professionals and companies.",
      "For those seeking aesthetics, performance and lasting quality."
    ],

    productsEyebrow: "Products",
    productsTitle: "Two worlds. One standard.",
    productsBody: "Choose your path: architectural systems for homes and offices, or pergolas and automatic covers for outdoor spaces.",
    catArchTitle: "Architectural Systems",
    catArchSub: "Aluminium and PVC windows and doors, sliding systems and solutions for contemporary architecture.",
    catPergoleTitle: "Pergolas & Covers",
    catPergoleSub: "Bioclimatic pergolas, glazing and outdoor solutions to enhance outdoor spaces.",

    contactEyebrow: "Contact",
    contactTitle: "Let's talk about your project.",
    contactBody: "Write us for a site visit, a quote, or a partnership brief. We reply within 24 hours.",
    contactShowroomTitle: "Our showroom",
    contactSend: "Send request",

    b2bLogin: "Reserved area",
    portal: "Reserved area",
    backToProducts: "Back to products",
    seeProducts: "See products",
    seeAll: "See all",
    startProject: "Get a quote",
    features: "Key features",
    finishes: "Available finishes",
    applications: "Typical applications",
    partOf: "Part of",
    brochureLabel: "Technical datasheet",
  },
};
